import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'ac-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ac-badge.component.html',
  styleUrl: './ac-badge.component.scss'
})
export class AcBadgeComponent {
  @Input() color: "primary" | "secondary" | "tertiary" | "success" | "warning" | "danger" | "light" | "medium" | "dark" | "outline" | string | undefined = "primary";

}

